export const environmentAll = {
    releaseVersion: 1.9,
    earliestReleaseVersion: 1.4,
    ignoredReleaseVersions: [ 1.7 ]
  };
